export enum Variant {
  Default = "default",
  PostMagazine = "post-magazine",
  Style = "style",
}
